import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/org/$org/people')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/$org/people',
      params: { org: params.org },
      search: { view: 'active', q: undefined },
    })
  },
})
